import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import { PrivateRoute } from "../utils/PrivateRouter";
import Login from "../views/Login/VLogin";
import { Rutas } from "./Rutas";
import BackDrop from "./../global/BackDrop";
import { useSelector } from "react-redux";
export default function Routes() {
    const {load, message} = useSelector(store => store.load)
    return (
        <div>
            <Router>
                <Switch>
                    {
                        Rutas.map(Ruta => {
                            const { key, path, exact, component, Clave } = Ruta
                            return (
                                <PrivateRoute key={key} idRuta={Clave} path={path} exact={exact} component={component} />
                            )
                        })
                    }
                    <Route path="/Login">
                        <Login />
                    </Route>
                    <Route path="/">
                        <Login />
                    </Route>
                </Switch>
            </Router>
            <BackDrop open={load} message={message} />
        </div>
    );
}